import React from 'react';
import Questionnaires from './Questionnaires';
import Questions from './Questions';
import Ordre from './Ordre';

export default function FrontController(props) {

        if(props.selectionSwitch === 'Question'){
            return (<Questions/>)
        }else if(props.selectionSwitch === 'Questionnaire'){
            return (<Questionnaires/>)
        }else if(props.selectionSwitch === 'Ordre'){
            return (<Ordre/>)
        }else {
        return (
            <div>
                <p>Bienvenue sur l'interface d'administration du formulaire d'évaluation à froid</p>
                <p>Ici, vous pouvez créer, modifier et supprimer des questions
                    ainsi que créer et supprimer les questionnaires qui seront envoyés.</p>
            </div>
        )
    }

}